import React from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { VisibilityOutlined, Close } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setViewAsRole } from "state";
import { getRoleDisplayName } from "utils/roleDisplay";

const VIEW_AS_HOME = {
  caller: "/dashboard",
};

const ViewAsBanner = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const viewAsRole = useSelector((s) => s.global.viewAsRole);
  const realUser = useSelector((s) => s.global.realUser);

  if (!viewAsRole || !realUser) return null;

  const exitView = () => {
    dispatch(setViewAsRole(null));
    navigate("/dashboard");
    window.location.reload();
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        px: { xs: 1.5, md: 2.5 },
        py: 0.75,
        bgcolor: theme.palette.mode === "dark" ? "rgba(251,191,36,0.12)" : "rgba(251,191,36,0.18)",
        borderBottom: `1px solid ${theme.palette.warning.main}44`,
      }}
    >
      <Box display="flex" alignItems="center" gap={1} minWidth={0}>
        <VisibilityOutlined sx={{ fontSize: 16, color: theme.palette.warning.dark, flexShrink: 0 }} />
        <Typography sx={{ fontSize: "0.78rem", color: theme.palette.text.primary }} noWrap>
          <Box component="span" sx={{ fontWeight: 700 }}>
            Viewing as {getRoleDisplayName(viewAsRole)}
          </Box>
          <Box component="span" sx={{ color: theme.palette.text.secondary }}>
            {" "}
            · logged in as {realUser.name}
          </Box>
        </Typography>
      </Box>
      <Button
        size="small"
        startIcon={<Close sx={{ fontSize: 14 }} />}
        onClick={exitView}
        sx={{
          textTransform: "none",
          fontSize: "0.72rem",
          borderRadius: "7px",
          flexShrink: 0,
          color: theme.palette.warning.dark,
          borderColor: `${theme.palette.warning.main}66`,
        }}
        variant="outlined"
      >
        Exit view
      </Button>
    </Box>
  );
};

export { VIEW_AS_HOME };
export default ViewAsBanner;
